const ITEMS = [
  "Systematic Investing",
  "Goal Planning",
  "Tax Saving · ELSS",
  "Retirement Corpus",
  "Wealth Compounding",
  "Portfolio Review",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      className="relative border-y border-black/10 bg-[#efe9de] py-6 overflow-hidden"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-2xl md:text-4xl text-[#1a1a17]/80 px-8">
              {item}
            </span>
            <span className="text-[#b8925a] text-xl">&#9670;</span>
          </div>
        ))}
      </div>
    </section>
  );
}
